<template>
  <div>
    <div v-if="['Home', 'Login', 'ResetPassword'].includes($route.name)">
      <BannerPolicies></BannerPolicies>
    </div>
    <footer id="main-footer" class="bg-dark text-white footer">
      <b-row>
        <b-col>
          <div class="copyright py-1 text-center">
            © {{ currentYear }} | LimeIQ LLC | All Rights Reserved. |
            <a
              class="text-white"
              @click.prevent.stop="$emitter.emit('toggle-termly-modal', 'privacy-policy')"
              href="#"
              >Privacy Policy</a
            >
            |
            <a
              href="#"
              class="text-white"
              @click.prevent.stop="
                $emitter.emit('toggle-termly-modal', 'terms-and-conditions')
              "
              >Terms & Conditions</a
            >
          </div>
        </b-col>
      </b-row>
    </footer>
  </div>
</template>

<script>
import BannerPolicies from "../components/BannerPolicies.vue";

export default {
  name: "app-footer",
  components: {
    BannerPolicies,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
